import noop from 'lodash/noop';
import React, { useContext } from 'react';

import { useScrollPositionInternal } from './UseScrollPositionInternal';

type ScrollPositionContext = ReturnType<typeof useScrollPositionInternal>;

const initialContext: ScrollPositionContext = {
  hasPageLoaded: false,
  setHasPageLoaded: noop,
  isAtPageTop: undefined,
};

const ScrollPositionContext = React.createContext<ScrollPositionContext>(initialContext);
ScrollPositionContext.displayName = 'ScrollPosition';

export const useScrollPositionContext = () => useContext(ScrollPositionContext);

export const ScrollPositionProvider: React.FC = ({ children }) => {
  return (
    <ScrollPositionContext.Provider value={useScrollPositionInternal()}>
      {children}
    </ScrollPositionContext.Provider>
  );
};

export const ScrollPositionConsumer = ScrollPositionContext.Consumer;
